import actionTypes from '../constants/action-types';

const setRenderStatus = (status) => ({
  type: actionTypes.SET_RENDER_STATUS,
  payload: {
    status,
  },
});

export default setRenderStatus;
